import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import CartView from "@/components/CartView";
import Reveal from "@/components/Reveal";

export default function Carrinho() {
    const [search, setSearch] = useSearchParams();

    useEffect(() => {
        if (search.get("cancelado")) {
            toast.info("Pagamento cancelado — seu carrinho continua salvo.");
            search.delete("cancelado");
            setSearch(search, { replace: true });
        }
    }, [search, setSearch]);

    return (
        <section className="pb-24 pt-28 md:pb-32 md:pt-40" data-testid="cart-page">
            <div className="zf-container">
                <Reveal>
                    <p className="zf-eyebrow">Carrinho</p>
                    <h1 className="mt-4 font-display text-4xl font-black uppercase leading-tight text-forge-paper md:text-6xl">
                        Seu <span className="text-forge-yellow">carrinho</span>
                    </h1>
                </Reveal>
                <Reveal delay={0.08} className="mt-12">
                    <CartView testPrefix="cart" />
                </Reveal>
            </div>
        </section>
    );
}
